module.exports = __webpack_public_path__ + "img/Youtube.3e4f8c0f.svg";